var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.84414,
    y: -3.87539,
    width: 21.4187,
    height: 23.2527
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_0_18165_13140_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18165_13140)",
    "data-figma-bg-blur-radius": 4.70937
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5041 2.44243C11.2392 2.38889 11.0321 2.16723 11.0321 1.89693V1.33398C11.0321 1.06065 10.8054 0.833984 10.5321 0.833984C10.2587 0.833984 10.0321 1.06065 10.0321 1.33398V1.81072C10.0321 2.09971 9.79778 2.33398 9.50879 2.33398H6.22198C5.93299 2.33398 5.69872 2.09971 5.69872 1.81072V1.33398C5.69872 1.06065 5.47205 0.833984 5.19872 0.833984C4.92539 0.833984 4.69872 1.06065 4.69872 1.33398V1.89693C4.69872 2.16723 4.49162 2.38889 4.22668 2.44243C2.74474 2.74192 2.01316 3.76012 1.89205 5.20732C1.87872 5.40065 2.03872 5.56065 2.22539 5.56065H13.5054C13.6987 5.56065 13.8587 5.39399 13.8387 5.20732C13.7176 3.76013 12.986 2.74192 11.5041 2.44243Z",
    fill: "url(#paint0_linear_18165_13140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5041 2.44243C11.2392 2.38889 11.0321 2.16723 11.0321 1.89693V1.33398C11.0321 1.06065 10.8054 0.833984 10.5321 0.833984C10.2587 0.833984 10.0321 1.06065 10.0321 1.33398V1.81072C10.0321 2.09971 9.79778 2.33398 9.50879 2.33398H6.22198C5.93299 2.33398 5.69872 2.09971 5.69872 1.81072V1.33398C5.69872 1.06065 5.47205 0.833984 5.19872 0.833984C4.92539 0.833984 4.69872 1.06065 4.69872 1.33398V1.89693C4.69872 2.16723 4.49162 2.38889 4.22668 2.44243C2.74474 2.74192 2.01316 3.76012 1.89205 5.20732C1.87872 5.40065 2.03872 5.56065 2.22539 5.56065H13.5054C13.6987 5.56065 13.8587 5.39399 13.8387 5.20732C13.7176 3.76013 12.986 2.74192 11.5041 2.44243Z",
    fill: "url(#paint1_linear_18165_13140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 6.56055H2.5319C2.16523 6.56055 1.86523 6.86055 1.86523 7.22721V11.3339C1.86523 13.3339 2.86523 14.6672 5.19857 14.6672H10.5319C12.8652 14.6672 13.8652 13.3339 13.8652 11.3339V7.22721C13.8652 6.86055 13.5652 6.56055 13.1986 6.56055Z",
    fill: "url(#paint2_linear_18165_13140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 6.56055H2.5319C2.16523 6.56055 1.86523 6.86055 1.86523 7.22721V11.3339C1.86523 13.3339 2.86523 14.6672 5.19857 14.6672H10.5319C12.8652 14.6672 13.8652 13.3339 13.8652 11.3339V7.22721C13.8652 6.86055 13.5652 6.56055 13.1986 6.56055Z",
    fill: "url(#paint3_linear_18165_13140)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18165_13140",
    x: -2.84414,
    y: -3.87539,
    width: 21.4187,
    height: 23.2527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.654079,
    dy: 0.654079
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.32704
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18165_13140"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_18165_13140_clip_path",
    transform: "translate(2.84414 3.87539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5041 2.44243C11.2392 2.38889 11.0321 2.16723 11.0321 1.89693V1.33398C11.0321 1.06065 10.8054 0.833984 10.5321 0.833984C10.2587 0.833984 10.0321 1.06065 10.0321 1.33398V1.81072C10.0321 2.09971 9.79778 2.33398 9.50879 2.33398H6.22198C5.93299 2.33398 5.69872 2.09971 5.69872 1.81072V1.33398C5.69872 1.06065 5.47205 0.833984 5.19872 0.833984C4.92539 0.833984 4.69872 1.06065 4.69872 1.33398V1.89693C4.69872 2.16723 4.49162 2.38889 4.22668 2.44243C2.74474 2.74192 2.01316 3.76012 1.89205 5.20732C1.87872 5.40065 2.03872 5.56065 2.22539 5.56065H13.5054C13.6987 5.56065 13.8587 5.39399 13.8387 5.20732C13.7176 3.76013 12.986 2.74192 11.5041 2.44243Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1986 6.56055H2.5319C2.16523 6.56055 1.86523 6.86055 1.86523 7.22721V11.3339C1.86523 13.3339 2.86523 14.6672 5.19857 14.6672H10.5319C12.8652 14.6672 13.8652 13.3339 13.8652 11.3339V7.22721C13.8652 6.86055 13.5652 6.56055 13.1986 6.56055Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18165_13140",
    x1: 7.86523,
    y1: 0.833984,
    x2: -3.71861,
    y2: 12.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18165_13140",
    x1: 7.86524,
    y1: 0.833984,
    x2: 11.8601,
    y2: 16.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18165_13140",
    x1: 7.86523,
    y1: 0.833984,
    x2: -3.71861,
    y2: 12.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18165_13140",
    x1: 7.86524,
    y1: 0.833984,
    x2: 11.8601,
    y2: 16.0124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarMini);
export default __webpack_public_path__ + "static/media/calendar-mini.7305926a6532cee806bf6ee834edb4a9.svg";
export { ForwardRef as ReactComponent };